module.exports = __webpack_public_path__ + "img/foot_icon_2.00856dc7.svg";